import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { initialBalancesApi } from 'src/Services/API';

const useFetchInitialBalancesAudit = () => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['fetch-initial-balances-audit', assetId],
    queryFn: async () => {
      if (!assetId) throw new Error('No assetId provided');

      return (await initialBalancesApi.initialBalancesControllerFindAudit(assetId)).data;
    },
    enabled: !!assetId,
  });
};

export default useFetchInitialBalancesAudit;
